import React, { Component } from 'react';
import withRouter from '../../../services/util/withRouter';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Container, Row, Col } from 'reactstrap';
import classes from './DeviceMonitor.module.css';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ProgressBar from 'react-bootstrap/ProgressBar';
import {
	GreenAccessButton,
	RedAccessButton
} from '../../../components/Machines/MachineComponents';
import realtime from '../../../services/api/realtime';
import DatePicker from 'react-datepicker';
import { now } from 'moment';
import { ROLES } from '../../../services/util/consts';

//--------- Command Panel prototype ------------

class CommandPanel extends Component {
	state = {
		infoText: '',
		logDate: now(),
		currentStep: 0,
		stepCount: 0,
	};
	subscriptions = [];

	componentDidMount() {
		this.subscriptions.push(
		// Subscribe to necessary realtime events here
		realtime.subscribeCommandResult(this.props.machine.hardwareID, (data, params) => {
			if (data.c?.toLocaleUpperCase() == realtime.remoteCommandsResult.remotePriceCheckProgress.toLocaleUpperCase()) {
				this.setState({
					currentStep: data.p?.currentStep,
					stepCount: data.p?.stepCount
				});
			}
		}));
	}

	componentWillUnmount() {
		// Unsubscribe from all realtime events to prevent memory leaks
		this.subscriptions.forEach((subscription) => subscription.unsubscribe());
	}

	//StandByInfoTextDialog rendering and handleing

	showStandByInfoTextDialog() {
		this.setState({ showStandByInfoTextDialog: true });
	}

	hideStandByInfoTextDialog() {
		this.setState({ showStandByInfoTextDialog: false, infoText: '' });
		//	this.loadData();
	}

	// Get Log File Dialog rendering and handling
	showGetLogDialog() {
		this.setState({ showGetLogDialog: true });
	}

	hideGetLogDialog() {
		this.setState({ showGetLogDialog: false });
	}

	// Reboot Confirmation Dialog rendering and handling
	showRebootConfirmationDialog() {
		this.setState({
			showRebootConfirmationDialog: true
		});
	}

	hideRebootConfirmationDialog() {
		this.setState({
			showRebootConfirmationDialog: false
		});
	}

	// Remote Price Check Confirmation Dialog rendering and handling
	showRemotePriceCheckConfirmationDialog() {
		this.setState({
			priceCheckSelection: (
				this.props.remotePriceCheckProducts?.products || []
			).map((product) => !!product.checked),
			showRemotePriceCheckConfirmationDialog: true
		});
	}

	hideRemotePriceCheckConfirmationDialog() {
		this.setState({
			showRemotePriceCheckConfirmationDialog: false
		});
	}

	sendInfotext = () => {
		realtime.sendCommand(
			this.props.machine.hardwareID,
			realtime.remoteCommands.setInfoText,
			this.state.infoText
		);
		this.hideStandByInfoTextDialog();
	};

	handleStartStopDebug() {
		if (this.state.isDebugging) {
			realtime.sendCommand(
				this.props.machine.hardwareID,
				realtime.remoteCommands.stopDebug,
				''
			);
			this.setState({
				isDebugging: false
			});
		} else {
			realtime.sendCommand(
				this.props.machine.hardwareID,
				realtime.remoteCommands.startDebug,
				''
			);
			this.setState({
				isDebugging: true
			});
		}
	}

	inputChangeHandler = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	};

	renderSetStandbyText() {
		const { t } = this.props;
		return (
			<Modal
				show={this.state.showStandByInfoTextDialog}
				onHide={() => this.hideStandByInfoTextDialog()}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<i class="icon-clipboard" style={{ marginRight: '10px' }}></i>
						{t('commandPanel.stbyInfo')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Group>
							<Form.Label>{t('commandPanel.stbyInfo') + ' :'}</Form.Label>
							<Form.Control
								name="infoText"
								type="text"
								as="textarea"
								rows={10}
								placeholder={t('commandPanel.stbyInfo')}
								value={this.state.infoText}
								onChange={this.inputChangeHandler}
							/>
						</Form.Group>
					</Form>
					<Row>
						<Col>
							<Button variant="success" onClick={() => this.sendInfotext()}>
								{t('commandPanel.send')}
							</Button>
						</Col>
						<Col
							style={{
								display: 'flex',
								felxDirection: 'collumn',
								justifyContent: 'flex-end'
							}}
						>
							<Button
								variant="primary"
								onClick={() => this.hideStandByInfoTextDialog()}
							>
								{t('commandPanel.cancel')}
							</Button>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		);
	}

	renderGetLogFileDialog() {
		const { t } = this.props;
		return (
			<Modal
				show={this.state.showGetLogDialog}
				onHide={() => this.hideGetLogDialog()}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<i class="icon-clipboard" style={{ marginRight: '10px' }}></i>
						{t('commandPanel.getLogFile')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Group>
							<div style={{ textAlign: 'center' }}>
								<Form.Label>{t('commandPanel.getLogFile') + ' :'}</Form.Label>

								<DatePicker
									selected={this.state.logDate}
									dateFormat="yyyy MMMM d"
									onChange={(date) => {
										this.setState({ logDate: date });
									}}
								/>
							</div>
						</Form.Group>
					</Form>
					<Row>
						<Col>
							<Button
								variant="success"
								onClick={() => {
									this.sendGetLogCommand();
									this.hideGetLogDialog();
								}}
							>
								{t('commandPanel.send')}
							</Button>
						</Col>
						<Col
							style={{
								display: 'flex',
								felxDirection: 'collumn',
								justifyContent: 'flex-end'
							}}
						>
							<Button variant="primary" onClick={() => this.hideGetLogDialog()}>
								{t('commandPanel.cancel')}
							</Button>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		);
	}

	renderRebootConfirmation() {
		const { t } = this.props;
		return (
			<Modal
				show={this.state.showRebootConfirmationDialog}
				onHide={() => this.hideRebootConfirmationDialog()}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<i class="icon-clipboard" style={{ marginRight: '10px' }}></i>
						{t('commandPanel.rebootRunner')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Group>
							<Form.Label>
								{t('commandPanel.rebootRunnerConfirmation')}
							</Form.Label>
						</Form.Group>
					</Form>
					<Row>
						<Col>
							<Button
								variant="success"
								onClick={() => this.sendRebootCommand()}
							>
								{t('commandPanel.yes')}
							</Button>
						</Col>
						<Col
							style={{
								display: 'flex',
								felxDirection: 'collumn',
								justifyContent: 'flex-end'
							}}
						>
							<Button
								variant="primary"
								onClick={() => this.hideRebootConfirmationDialog()}
							>
								{t('commandPanel.no')}
							</Button>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		);
	}

	renderRemotePriceCheckConfirmation() {
		const { t, priceCheckActive } = this.props;
		const products = this.props.remotePriceCheckProducts?.products || [];
		const selection = this.state.priceCheckSelection || [];
		const hadProductLamps = this.props.remotePriceCheckProducts?.hasProductLamps;
		return (
			<Modal
				show={this.state.showRemotePriceCheckConfirmationDialog}
				onHide={() => this.hideRemotePriceCheckConfirmationDialog()}
				scrollable
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<i className="icon-clipboard" style={{ marginRight: '10px' }}></i>
						{t('commandPanel.remotePriceCheck')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div
						style={{
							maxHeight: '40vh',
							overflowY: 'auto',
							marginBottom: '10px'
						}}
					>
						{products.map((product, index) => (
							<div
								key={index}
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									padding: '8px 12px',
									background: index % 2 ? '#e9ecef' : '#f8f9fa'
								}}
							>
								<div>
									<strong>
										{product.name || product.productName || product.n}
									</strong>
									{product.machine && (
										<div>
											{t('commandPanel.machineRole')}: {product.machine}
										</div>
									)}
								</div>
								<div style={{ textAlign: 'right', flex: 1 }}>
									<div>
										{t('commandPanel.price')}:{' '}
										<strong>{product.price ?? product.pr}</strong>
									</div>
									<div>
										{t('commandPanel.button')}: {product.buttonId}
									</div>
								</div>
								{hadProductLamps && (
									
										<span style={{ marginLeft: '15px' }}
											className={
												product.productLamp ? classes.LampRed : classes.LampGray
											}
										/>
									
								)}
								<input
									type="checkbox"
									style={{
										marginLeft: '15px',
										marginRight: '15px',
										alignSelf: 'center',
										width: '20px',
										height: '20px'
									}}
									checked={!!selection[index]}
									onChange={(e) => {
										const next = [...selection];
										next[index] = e.target.checked;
										this.setState({ priceCheckSelection: next });
									}}
								/>
							</div>
						))}
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: '10px',
							marginBottom: '15px'
						}}
					>
						<Button
							size="sm"
							variant="secondary"
							onClick={() =>
								this.setState({ priceCheckSelection: products.map(() => true) })
							}
						>
							{t('commandPanel.selectAll')}
						</Button>
						<Button
							size="sm"
							variant="secondary"
							onClick={() =>
								this.setState({
									priceCheckSelection: products.map(() => false)
								})
							}
						>
							{t('commandPanel.deselectAll')}
						</Button>
					</div>
					<div
						style={{
							background: '#e9ecef',
							borderRadius: '12px',
							padding: '15px'
						}}
					>
						<h5>{t('commandPanel.operatingInstructions')}</h5>
						<ul style={{ marginBottom: 0 }}>
							{[1, 2, 3, 4, 5].map((i) => (
								<li key={i}>{t('commandPanel.priceCheckInstruction' + i)}</li>
							))}
						</ul>
					</div>
				</Modal.Body>
				{priceCheckActive ? (
					<Modal.Footer style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
						{this.state.stepCount > 0 && (
							<div style={{ width: '100%', marginBottom: '10px' }}>
								<ProgressBar
									now={Math.min(
										100,
										(this.state.currentStep / this.state.stepCount) * 100
									)}
									label={(this.state.currentStep / this.state.stepCount) > 0.1 ? `${this.state.currentStep} / ${this.state.stepCount}` : ''}
								/>
							</div>
						)}
						<div>{this.props.t('remoteControl.lastEventPriceCheckStart')}</div>
						<Button
							variant="primary"
							onClick={() => this.sendStopPriceCheckCommand()}
						>
							{t('commandPanel.stop')}
						</Button>
					</Modal.Footer>
				) : (
					<Modal.Footer style={{ justifyContent: 'space-between' }}>
						<Button
							variant="primary"
							onClick={() => this.hideRemotePriceCheckConfirmationDialog()}
						>
							{t('commandPanel.cancel')}
						</Button>
						<Button
							variant="success"
							onClick={() => this.sendPriceCheckStartedCommand()}
						>
							{t('commandPanel.start')}
						</Button>
					</Modal.Footer>
				)}
			</Modal>
		);
	}

	sendGetScreenshotCommand() {
		realtime.sendCommand(
			this.props.machine.hardwareID,
			realtime.remoteCommands.takeScreenshot
		);
	}

	leadingZero(num, size) {
		num = num.toString();
		while (num.length < size) num = '0' + num;
		return num;
	}

	sendGetLogCommand() {
		const date = new Date(this.state.logDate);
		const dateString =
			date.getFullYear() +
			'.' +
			this.leadingZero(date.getMonth() + 1, 2) +
			'.' +
			this.leadingZero(date.getDate(), 2);
		realtime.sendCommand(
			this.props.machine.hardwareID,
			realtime.remoteCommands.getLogFile,
			dateString
		);
	}

	sendRebootCommand() {
		realtime.sendCommand(
			this.props.machine.hardwareID,
			realtime.remoteCommands.rebootRunner
		);
		this.hideRebootConfirmationDialog();
	}

	sendStopPriceCheckCommand() {
		realtime.sendCommand(
			this.props.machine.hardwareID,
			realtime.remoteCommands.stopRemotePriceChecking
		);
		this.hideRemotePriceCheckConfirmationDialog();
	}

	sendPriceCheckStartedCommand() {
		const { priceCheckSelection } = this.state;
		const selectedProducts = priceCheckSelection
			.map((selected, index) => ({
				productAssignmentId:
					this.props.remotePriceCheckProducts?.products[index]
						?.productAssignmentId,
				checked: selected
			}))
			.filter((product) => product.checked);

		this.setState({
			currentStep: 0,
			stepCount: 0,
		})

		realtime.sendCommand(
			this.props.machine.hardwareID,
			realtime.remoteCommands.startRemotePriceChecking,
			{ paId: selectedProducts.map((product) => product.productAssignmentId) }
		);		
	}

	render() {
		const { t, machine } = this.props;

		let debugButton = null;
		if (
			this.props.usePrivilege &&
			this.props.usePrivilege.privilege == ROLES.root
		) {
			if (!this.state.isDebugging) {
				debugButton = (
					<GreenAccessButton onClick={() => this.handleStartStopDebug()}>
						<i className="fa fa-play mr-3" />
						{t('commandPanel.startDebug')}
					</GreenAccessButton>
				);
			} else {
				debugButton = (
					<RedAccessButton onClick={() => this.handleStartStopDebug()}>
						<i className="fa fa-stop mr-3" />
						{t('commandPanel.stopDebug')}
					</RedAccessButton>
				);
			}
		}

		return (
			<Container style={{ maxWidth: '100%' }}>
				{this.renderSetStandbyText()}
				{this.renderGetLogFileDialog()}
				{this.renderRebootConfirmation()}
				{this.renderRemotePriceCheckConfirmation()}
				<Row className={classes.CommandRow}>
					<Col md="4" xs="12">
						{t('commandPanel.title')}
					</Col>
					<Col
						md="1"
						xs="12"
						style={{ textAlign: 'right', minHeight: '1rem' }}
					></Col>
					<Col
						md="7"
						xs="12"
						style={{ textAlign: 'center' }}
						className={classes.BtnCol}
					>
						<GreenAccessButton onClick={() => this.showStandByInfoTextDialog()}>
							<i className="fa fa-clipboard mr-2" />
							{t('commandPanel.stbyInfo')}
						</GreenAccessButton>
						<GreenAccessButton onClick={() => this.sendGetScreenshotCommand()}>
							<i className="fa fa-desktop mr-3" />
							{t('commandPanel.scrShot')}
						</GreenAccessButton>
						<GreenAccessButton onClick={() => this.showGetLogDialog()}>
							<i className="fa fa-file mr-3" />
							{t('commandPanel.getLog')}
						</GreenAccessButton>
						<GreenAccessButton
							onClick={() => this.showRebootConfirmationDialog()}
						>
							<i className="fa fa-repeat mr-3" />
							{t('commandPanel.rebootRunner')}
						</GreenAccessButton>
						{!!this.props.remotePriceCheckProducts ? (
							<GreenAccessButton
								onClick={() => this.showRemotePriceCheckConfirmationDialog()}
							>
								<i className="fa fa-check-circle mr-3" />
								{t('commandPanel.remotePriceCheck')}
							</GreenAccessButton>
						) : null}
						{debugButton}
					</Col>
				</Row>
			</Container>
		);
	}
}

const mapStateToProps = (state) => ({
	usePrivilege: state.user
});

export default withRouter(
	connect(mapStateToProps)(withTranslation()(CommandPanel))
);
